import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = s(
  (r, a) => /* @__PURE__ */ o.jsx(
    t,
    {
      ref: a,
      ...r,
      image: (e) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...e,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8.676 1.263a1 1 0 0 0-1.352 0l-6 5.5A1 1 0 0 0 1 7.5V14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.5a1 1 0 0 0-.324-.737z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "HomeIcon";
export {
  i as HomeIcon,
  i as default
};
//# sourceMappingURL=index.js.map
